import { getLocalStorage } from "./storage";

const TOKEN_STORAGE_KEY = "mm_backoffice_jwt";

export function getStoredToken() {
  const storage = getLocalStorage();
  if (!storage) {
    return null;
  }

  return storage.getItem(TOKEN_STORAGE_KEY);
}

export function persistToken(token) {
  const storage = getLocalStorage();
  if (!storage) {
    return;
  }

  if (token) {
    storage.setItem(TOKEN_STORAGE_KEY, token);
  } else {
    storage.removeItem(TOKEN_STORAGE_KEY);
  }
}

export function clearStoredToken() {
  persistToken(null);
}

export { TOKEN_STORAGE_KEY };
